import { ProposalCopyingForRecalConstant } from "presentation/constant/ProposalCopyingForRecal/ProposalCopyingForRecalConstant";
import { useProposalCopyingForRecalVM } from "presentation/hook/ProposalCopyingForRecal/useProposalCopyingForRecalVM";
import { useProposalCopyingForRecalTracked } from "presentation/store/ProposalCopyingForRecal/ProposalCopyingForRecalProvider";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import { memo, useCallback } from "react";
import { IconButton } from "veronica-ui-component/dist/component/core";
import { Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const ProposalCopyingForRecalTitleBar: React.FC = () => {
    const [proposalCopyingForRecalState] = useProposalCopyingForRecalTracked();
    const proposalCopyingForRecalVM = useProposalCopyingForRecalVM();
    const { isShowTariffItemPanel } = proposalCopyingForRecalState;
    const SCREEN_CONSTANT = ProposalCopyingForRecalConstant.Title;


    const handleSearch = useCallback(async () => {
        proposalCopyingForRecalVM.onSearchClick();
    }, [proposalCopyingForRecalVM]);


    return <Sidebarheader style={{ width: '100%', display: "flex", alignItems: "center" }}>
        <HeaderTitle>{SCREEN_CONSTANT.TITLE}</HeaderTitle>
        <StyledAction className="tm-animated-wrapper">
            <IconButton fileName='Icon-search' disabled={isShowTariffItemPanel} size='medium' toolTipText={'Search'} toolTipArrow={false} onClick={handleSearch} />
        </StyledAction>
    </Sidebarheader>
}

export default memo(ProposalCopyingForRecalTitleBar);